
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"13","cy":"13","r":"13","fill":"#122546"}}),_c('path',{attrs:{"d":"M13.5 5.417a2.125 2.125 0 100 4.25 2.125 2.125 0 000-4.25zm-2.125 5.666a.707.707 0 100 1.417h.708v5.667h-.708a.709.709 0 100 1.416h4.25a.709.709 0 100-1.416h-.709v-6.375a.709.709 0 00-.708-.709h-2.833z","fill":"#fff"}})])
          )
        }
      }
    